export default {
  pager: (state) => state.pager,
  isChecked: (state) => state.isChecked,
  stateprovinces: (state) => state.stateprovinces,
  timezones: (state) => state.timezones,
  applications: (state) => state.applications,
  application: (state) => state.application,
  assessmentTypes: (state) => state.assessmentTypes,
  assessments: (state) => state.assessments,
  assessment: (state) => state.assessment,
  settings: (state) => state.settings,
  setting: (state) => state.setting,
  assessmentNorms: (state) => state.assessmentNorms,
  biTemplates: (state) => state.biTemplates,
  selectedBiTemplate: (state) => state.selectedBiTemplate,
}
